import React, { useState } from "react";
import { forgotPassword } from "../../../redux/auth/actions";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import parsePhoneNumber from "libphonenumber-js";
import { Toaster, ToasterNew } from "../../../utils/toaster";
import { APP_CONST, AuthModals } from "../../../config/const";
import { Modal } from "react-bootstrap";
import AppButton from "../Ui/AppButton";

const ForgotPassword = ({ show, handleModalChange }) => {
  const navigate = useNavigate();
  const [mobileNumber, setMobileNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!mobileNumber) {
      ToasterNew.Error("Mobile number is required");
      return;
    }
    const phoneNumber = parsePhoneNumber("+" + mobileNumber);
    if (!phoneNumber) {
      ToasterNew.Error("Something went wrong");
      return;
    }

    setIsLoading(true);
    const response = await forgotPassword({
      phone: phoneNumber?.nationalNumber,
      countryCode: phoneNumber?.countryCallingCode,
    });

    setIsLoading(false);

    if (response) {
      Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "OTP sent");
      handleModalChange(AuthModals.ResetPassword);
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-modal signup-modal"}
      placement={"end"}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        closeButton
        onClick={() => handleModalChange(null)}
        closeVariant="white"
      >
        {/* <Modal.Title style={{ color: "#013862" }}>Forgot Password</Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        <div className="login-section">
          <div className="Login-rightPart">
            <div className="form-steps">
              <h2 className="h2">Forgot Password</h2>
              {/* <p>
                Welcome back, you've
                <br />
                been missed!
              </p> */}
              <Form>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <PhoneInput
                    country={"in"}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    onlyCountries={["in"]}
                    inputStyle={{
                      display: "block",
                      width: "100%",
                      lineHeight: 1.5,
                      color: "#ffffff",
                      backgroundColor: "#26324B",
                      backgroundClip: "padding-box",
                      border: "#26324B",
                      borderRadius: "10px",
                      padding: "0.7rem 0.75rem",
                      borderColor: "#26324B",
                      fontSize: "0.86rem",
                      minHeight: "41px",
                      paddingLeft: "50px",
                    }}
                    onChange={(phone) => {
                      setMobileNumber(phone);
                    }}
                  />
                </Form.Group>
              </Form>
              <div className="d-flex justify-content-center">
                <AppButton
                  type="button"
                  variant="primary"
                  text="Submit"
                  isLoading={isLoading}
                  onClick={handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ForgotPassword;
